import { showInfoMessage } from 'components/Helpers/Toasts';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { usePersistStore } from 'store/usePersistStore';

export const WAIT_BEFORE_RELOAD_MS = 2000;

export const useHandleActionsAfterLogin = () => {
    const { t } = useTranslation();

    const updateUserEntryState = usePersistStore((store) => store.updateUserEntryState);
    const router = useRouter();

    const handleActionsAfterLogin = (rewriteUrl: string | undefined, showCartMergeInfo: boolean) => {
        updateUserEntryState('login');

        const refreshPage = () => {
            if (rewriteUrl) {
                router.replace(rewriteUrl).then(() => router.reload());
            } else {
                router.reload();
            }
        };

        if (showCartMergeInfo) {
            showInfoMessage(t('Your cart has been modified. Please check the changes.'));
            setTimeout(refreshPage, WAIT_BEFORE_RELOAD_MS);
        } else {
            refreshPage();
        }
    };

    return handleActionsAfterLogin;
};
